import React from "react";
 import ReactDOM from "react-dom/client";
 import "./index.css";

const books =[
    {id:1,img:'https://m.media-amazon.com/images/I/51JtK7GW3RL._SX324_BO1,204,203,200_.jpg', title:'War of Lanka (Ram Chandra Series Book 4)', author:'Amish Tripathi'  },
    {id:2,img:'https://m.media-amazon.com/images/I/51W-r3VQlAL._SX320_BO1,204,203,200_.jpg', title:'It All Starts With Us ', author:' Collen Hoover'  },
    {id:3,img:'https://m.media-amazon.com/images/I/51QnuLIY2uL._SX322_BO1,204,203,200_.jpg', title:'The Power of Your Subconscious Mind', author:' Joseph Murphy'  },
    {id:4,img:"https://m.media-amazon.com/images/I/51PJyvcfPGL._SX321_BO1,204,203,200_.jpg",title:"Life's Amazing Secrets",author:"Gaur Gopal Das"},
    {id:5,img:"https://m.media-amazon.com/images/I/516pmXNNmCL._SX324_BO1,204,203,200_.jpg",title:"The Subtle Art of Not Giving a F*ck",author:"Mark Manson"},
    {id:6,img:"https://m.media-amazon.com/images/I/41W-o6xu2bL._SX323_BO1,204,203,200_.jpg",title:"Do It Today",author:"Darius Foroux"},
    {id:7,img:"https://m.media-amazon.com/images/I/310ILDQr5lL._SX251_BO1,204,203,200_.jpg",title:"Bhagavad Gita",author:"Shree Krishna"},
    {id:8,img:"https://m.media-amazon.com/images/I/61ck5XWxB3L._SX324_BO1,204,203,200_.jpg",title:"Grandma's Bag of Stories",author:"Sudha Murty"},
    {id:9,img:"https://m.media-amazon.com/images/I/51TYGq2X7rL._SX322_BO1,204,203,200_.jpg",title:"How to Win Friends and Influence People",author:"Dane Carnegie"},
    {id:10,img:"https://m.media-amazon.com/images/I/611t1AEK2GL._SX322_BO1,204,203,200_.jpg",title:"Stories & Sutras",author:"Virat Chairania"},
    {id:11,img:"https://m.media-amazon.com/images/I/41oYp387k8L._SX319_BO1,204,203,200_.jpg",title:"Do Epic Shit",author:"Ankur Warikoo"},
    {id:12,img:"https://m.media-amazon.com/images/I/41F8ATXoMOL._SX317_BO1,204,203,200_.jpg",title:"Attitude Is Everything: Change Your Attitude ... Change Your Life!",author:"Jeff Keller"},
    {id:13,img:"https://m.media-amazon.com/images/I/41ZgK6u73qL._SX313_BO1,204,203,200_.jpg",title:"Man's Search For Meaning",author:"Viktor E Frankl"},
    {id:14,img:"https://m.media-amazon.com/images/I/51ewXeUdkvL._SX312_BO1,204,203,200_.jpg",title:"Karma: A Yogi's Guide to Crafting Your Destiny",author:"Sadhguru"},
    {id:15,img:"https://m.media-amazon.com/images/I/410BqHSamiL._SX322_BO1,204,203,200_.jpg",title:"The Monk Who Sold His Ferrari",author:"Robin Sharma"},
];

function Booklist(){
    return(
    <section className="booklist">
        {books.map((book)=>{
            return <Book {...book} key={book.id}></Book>;
        })}
    </section>
    )
};

const Book=({img,title,author})=>{
    
    const AddToCart=(title)=>{
        console.log(title,`added to cart`);}
    const displayAuthor=(author)=>{
        console.log(author);
    }

    return(
    <>
    <article className="book" onMouseOver={()=>displayAuthor(author)}>
    <img src={img}></img>
    <h2>{title}</h2>
    <h4>{author}</h4>
     <button onClick={()=>AddToCart(title)}> Added to cart </button>
    </article>
    </>
    )
}



ReactDOM.createRoot(document.getElementById("root")).render(<Booklist />);